import { ProductFeatureV3 } from '@chilipiper/api-client/src/user-availability'

export const getCrmExplicitsFromMeetingAttemptProductFeature = (
  productFeature?: ProductFeatureV3
) => {
  if (productFeature?.type === 'HandoffRouting') {
    return
  }

  return productFeature?.crmExplicits
}
